import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59 32">
      <g stroke="#000" fill="none">
        <path
          stroke-width="1.25"
          d="M5.13 31.393A4.135 4.135 0 0 1 1 27.263V5.13A4.135 4.135 0 0 1 5.13 1h48.245a4.135 4.135 0 0 1 4.131 4.13v22.133a4.135 4.135 0 0 1-4.13 4.13H5.13Z"
        />
        <path d="M51.286 12.154a4.117 4.117 0 1 1-8.235 0 4.117 4.117 0 0 1 8.235 0ZM49.642 22.776a2.474 2.474 0 1 1-4.947 0 2.474 2.474 0 0 1 4.947 0ZM37.256 23.714v-8.141c0-.787-.643-1.43-1.43-1.43H9.687c-.787 0-1.43.643-1.43 1.43v8.141c0 .786.643 1.43 1.43 1.43h26.14c.787 0 1.43-.644 1.43-1.43Zm-24.937-4.41h3.943-3.943Zm17.002 0h3.942-3.942Zm-8.378 1.39h3.942-3.942ZM8.256 8.145h29-29Z" />
      </g>
    </svg>
  );
};

export default Icon;
